// How a lead reads in Linus's inbox: the subject line and the labelled fields.
// Plain JS so api/lead.js (server) and the browser Web3Forms path share one wording.

export const CONTACT_TYPE = 'contact';

export function isContact(lead) {
  return lead.type === CONTACT_TYPE;
}

export function subjectFor(lead) {
  if (isContact(lead)) {
    const who = lead.name ? `${lead.name} (${lead.email})` : lead.email;
    return `Contact form: ${who}${lead.company ? ` at ${lead.company}` : ''}`;
  }
  return `White paper download: ${lead.paperTitle} from ${lead.email}${lead.returning ? ' (returning reader)' : ''}`;
}

export function leadLines(lead) {
  const utm = Object.entries(lead.utm || {}).map(([key, value]) => `${key}=${value}`).join(', ');
  if (isContact(lead)) {
    return [
      ['Form', 'Contact'],
      ['Email', lead.email],
      ['Name', lead.name],
      ['Company', lead.company],
      ['Message', lead.message],
      ['How they heard about us', lead.heardFrom],
      ['Page', lead.page],
      ['Referrer', lead.referrer],
      ['UTM', utm],
    ].filter(([, value]) => value);
  }
  return [
    ['White paper', lead.paperTitle],
    ['Email', lead.email],
    ['Name', lead.name],
    ['Company', lead.company],
    ['Page', lead.page],
    ['Referrer', lead.referrer],
    ['UTM', utm],
    ['Returning reader', lead.returning ? 'yes' : ''],
  ].filter(([, value]) => value);
}
